import r from '../utils/request'

// Gifts: a year of Pro or Family Pro, or a cookbook voucher, for someone else

export const getGiftOptions = () => r.get('/gifts/options')

export const giftCheckout = (params) => r.post('/gifts/checkout', params)

export const getGifts = () => r.get('/gifts')

export const getGift = (id) => r.get(`/gifts/${id}`)

export const redeemGift = (code) => r.post('/gifts/redeem', { code })

export const getVouchers = () => r.get('/gifts/vouchers')

export const GIFT_STATUS_TEXT = {
  pending_payment: 'Waiting for payment',
  paid: 'Scheduled',
  delivered: 'Sent',
  redeemed: 'Opened',
  used: 'Used',
  cancelled: 'Not paid',
}
